export default {

  addEmpty(programType) {
    return env.API.post('/user/program/add', { type : programType });
  },
  updateGeneralStep(id, data) {
    return env.API.post(`/user/program/${id}/general`, data)
  },
  getPrograms(filters) {
    return env.API.post('/user/program/getAll', filters);
  },
  getProgramById(id) {
    return env.API.get(`/user/program/id/${id}`);
  },
  deleteProgram(id) {
    return env.API.post('/user/program/delete', { programId : id });
  },
  getAdjust(id) {
    return env.API.post('/user/program/adjust', { programId : id });
  },
  recalculateAdjust(id) {
    return env.API.post('/user/program/recalculateAdjust', { programId : id });
  },
  saveNForms(id, data) {
    return env.API.post('user/program/adjust/saveFNforms', {programId: id, data: data});
  },
  getCropStages(data) {
    return env.API.post(`user/crop/stages/parent`, data);
  },
  getCropStagesGET(id) {
    return env.API.get(`user/crop/stages/parent/${id}`);
  },
  previousCrops() {
    return env.API.get(`misc/previousCrop`)
  },
  getWaterTestsByField(fieldId) {
    return env.API.post('/test/water/byField', { fieldId : fieldId });
  },
  getTissueTestsByField(fieldId) {
    return env.API.post('/test/tissue/byField', { fieldId : fieldId });
  },
  getSoilTestsByField(fieldId) {
    return env.API.post('/test/soil/byField', { fieldId : fieldId });
  },
  getMediaAnalyzesByField(fieldId) {
    return env.API.post('/test/media/byField', { fieldId : fieldId });
  },

  addWaterTestToProgram(testId, programId) {
    return env.API.post('user/program/connectWaterTest', { waterAnalysisId : testId, programId : programId });
  },
  addTissueTestToProgram(testId, programId) {
    return env.API.post('user/program/connectTissueTest', { tissueAnalysisId : testId, programId : programId });
  },
  addSoilTestToProgram(testId, programId) {
    return env.API.post('user/program/connectSoilTest', { soilTestId : testId, programId : programId });
  },
  addMediaAnalysisToProgram(testId, programId) {
    return env.API.post('user/program/connectMediaAnalysis', { mediaAnalysisId : testId, programId : programId });
  },

  addIrrigationToWaterTest(data) {
    return env.API.post('/test/water/irregation', data);
  },
  getIrrigationByProgramId(id) {
    return env.API.post('/test/water/getIrrigation', { programId : id });
  },

  removeTestFromProgram(type, id) {
    return env.API.post('user/program/disconnectTest', { type: type, id : id });
  },
  getBaseDressingNutrients() {
    return env.API.get('user/program/baseDressingNutrients')
  },
  getBaseDressingNutrientsTable(program) {
    return env.API.get(`user/program/${program}/nutrients-table`);
  },
  getBaseDressingResult(programId) {
    return env.API.post('user/program/baseDressing', { programId : parseInt(programId) });
  },
  saveBaseDressingNutrients(data) {
    return env.API.post('/user/program/saveBaseDressingNutrients', data)
  },
  manualBaseDressing(id, data) {
    return env.API.post(`/user/program/baseDressing/manual`, {programId: id, data: data})
  },

  getFertilizerSchedule(programId) {
    return env.API.post('/user/program/fertilizerSchedule', { programId : programId });
  },
  updateFertilizerSchedule(programId,  data) {
    data = JSON.stringify(data);
    var req = {programId: programId, data: data};
    // console.log(req);
    return env.API.post('/user/program/fertilizerScheduleManual', req);
  },


  getFertigationTanks(data) {
    return env.API.post('/program/fertigation/tanks/select', data);
  },
  updateFertigationTank(data) {
    return env.API.put('/program/fertigation/tank', data);
  },
  saveFertigationStep(data) {
    return env.API.put('/program/fertigation/save', data);
  },
  getFertigationStep(data) {
    return env.API.post('/program/fertigation/get', data);
  },
  updateFertigationTankWithApplication(data) {
    return env.API.put('/program/fertigation/tank/application', data);
  },
  updateFertigationTanksWithWaterPerStage(data) {
    return env.API.put('/program/fertigation/water-per-stage', data);
  },
  setProgramStep(data) {
    return env.API.put('/program/step', data);
  },
  getLimingMaterials() {
    return env.API.post(`user/liming/material/getAll`)
  },
  createLimingMaterial(data) {
    return env.API.post('user/liming/material/create', data);
  },
  getLimingResult(programId) {
    return env.API.post('user/liming/getResult', {programId :programId});
  },
  calculateLiming(data, programId) {
    return env.API.post('user/program/liming/calculate', {programId :programId, data: data})
  },
  calcBlend(data) {
    return env.API.post('/user/program/blend', data);
  },
  getBlend(program_id) {
    return env.API.get(`/program/${program_id}/blend`);
  },
  saveBlend(program_id, data) {
    return env.API.put(`/program/${program_id}/blend`, data);
  },
  finish(program_id) {
    return env.API.put(`/program/${program_id}/finish`);
  },

  clearCertainSteps(program_id, steps) {
    return env.API.post(`/program/${program_id}/steps/clear`, { steps });
  },
  getFertilizerSummary(program_id) {
    return env.API.get(`/program/${program_id}/fert-summary`);
  },
  checkGddLocation(program_id) {
    return env.API.post(`/program/gdd/checkLocation`, {programId: program_id});
  },
  recalculateGdd(program_id, data, temp, greenhouse) {
    return env.API.post(`/program/gdd/recalculateStageDuration`, {programId: program_id, stages: data, basalCropTemp: temp, greenhouse: greenhouse});
  },
  getGdd(program_id) {
    return env.API.post(`/program/gdd/getStages`, {programId: program_id})
  }
}
